import { render, staticRenderFns } from "./SidebarNavigation.vue?vue&type=template&id=1388fa5c&scoped=true"
import script from "./SidebarNavigation.vue?vue&type=script&lang=js"
export * from "./SidebarNavigation.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavigation.vue?vue&type=style&index=0&id=1388fa5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1388fa5c",
  null
  
)

export default component.exports